export default Object.freeze({
  NetAmount: 1,
  NetAfterProviderFees: 2,
  GrossAmount: 3,
  Margin: 4,
});
